/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useState, useMemo } from 'react';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BntVoltar from '../../../../components/bntVoltar';
import { useToast } from '../../../../context/ToastContext';

/*Import Requisição API*/
import api from '../../../../api';

export default function AdicionarEstoque() {
    const [produtos, setProdutos] = useState([]);
    const [carregando, setCarregando] = useState(true);
    const [termoPesquisa, setTermoPesquisa] = useState('');
    const [usuario_id, setIdUsuario] = useState();
    const [expandidos, setExpandidos] = useState({});
    const { showToast } = useToast();

    /* Variáveis auxiliares */
    const [salvando, setSalvando] = useState(false);

    /* Accordion controls */
    const toggleExpandido = (id) => {
        setExpandidos(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const expandirTodos = () => {
        const novosExpandidos = {};
        produtosFiltrados.forEach(p => { novosExpandidos[p.id_produto] = true; });
        setExpandidos(novosExpandidos);
    };

    const recolherTodos = () => {
        setExpandidos({});
    };

    const normalizarProdutos = (lista) => {
        if (!Array.isArray(lista)) return [];

        // Já vem agrupado com variacoes
        if (lista.some(item => Array.isArray(item.variacoes))) {
            return lista;
        }

        // Vem no formato flat (cada linha é uma variação)
        const produtosMap = {};
        lista.forEach(item => {
            if (!produtosMap[item.id_produto]) {
                produtosMap[item.id_produto] = {
                    id_produto: item.id_produto,
                    nome: item.nome,
                    descricao: item.descricao,
                    codigo_barras: item.codigo_barras,
                    marca: item.marca,
                    id_categoria: item.id_categoria,
                    id_fornecedor: item.id_fornecedor,
                    variacoes: []
                };
            }

            if (item.id_variacao !== undefined) {
                produtosMap[item.id_produto].variacoes.push({
                    id: item.id_variacao,
                    tamanho: item.tamanho,
                    cor: item.cor,
                    material: item.material,
                    preco_varejo: item.preco_varejo,
                    preco_atacado: item.preco_atacado,
                    preco_compra: item.preco_compra,
                    estoque: item.estoque,
                    sku: item.sku,
                    imagens: item.imagens || []
                });
            }
        });

        return Object.values(produtosMap);
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    useEffect(() => {
        async function carregarProdutos() {
            try {
                const response = await api.get('/listarprodutosAdm');
                if (response.data.success) {
                    const produtosNormalizados = normalizarProdutos(response.data.produtos);
                    const produtosComQuantidade = produtosNormalizados.map(produto => ({
                        ...produto,
                        variacoes: (produto.variacoes || []).map(v => ({ ...v, quantidadeAdicionar: 0 }))
                    }));
                    setProdutos(produtosComQuantidade);
                }
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
            } finally {
                setCarregando(false);
            }
        }
        carregarProdutos();
    }, []);

    const handleQuantidadeChange = (id_produto, id_variacao, valor) => {
        setProdutos(prev => prev.map(produto => {
            if (produto.id_produto !== id_produto) return produto;
            return {
                ...produto,
                variacoes: produto.variacoes.map(v =>
                    v.id === id_variacao
                        ? { ...v, quantidadeAdicionar: parseInt(valor) || 0 }
                        : v
                )
            };
        }));
    };

    const produtosFiltrados = useMemo(() =>
        produtos.filter((produto) =>
            produto.nome.toLowerCase().includes(termoPesquisa.toLowerCase())
        ), [produtos, termoPesquisa]
    );

    const variacoesComAdicao = useMemo(() =>
        produtos.flatMap(p =>
            (p.variacoes || []).filter(v => (v.quantidadeAdicionar || 0) > 0).map(v => ({ ...v, produto: p }))
        ), [produtos]
    );

    const handleSalvarEstoque = async () => {
        if (variacoesComAdicao.length === 0) {
            showToast('Nenhuma variação com quantidade para adicionar!', 'error');
            return;
        }

        setSalvando(true);

        try {
            let sucessos = 0;
            let erros = 0;

            for (const item of variacoesComAdicao) {
                try {
                    const novoEstoque = (parseInt(item.estoque) || 0) + item.quantidadeAdicionar;
                    const payload = { estoque: novoEstoque, usuario_id };
                    const response = await api.put(`/variacao/${item.id}/estoque`, payload);
                    if (response.data.success) {
                        sucessos++;
                    } else {
                        erros++;
                    }
                } catch (err) {
                    console.error(`Erro ao atualizar variação ${item.id}:`, err);
                    erros++;
                }
            }

            if (sucessos > 0) {
                showToast(`Estoque atualizado para ${sucessos} variação(ões)!`, 'success');
            }
            if (erros > 0) {
                showToast(`Erro ao atualizar ${erros} variação(ões)!`, 'error');
            }

            // Recarregar produtos
            const response = await api.get('/listarprodutosAdm');
            if (response.data.success) {
                const produtosNormalizados = normalizarProdutos(response.data.produtos);
                const produtosComQuantidade = produtosNormalizados.map(produto => ({
                    ...produto,
                    variacoes: (produto.variacoes || []).map(v => ({ ...v, quantidadeAdicionar: 0 }))
                }));
                setProdutos(produtosComQuantidade);
            }
        } catch (error) {
            console.error('Erro ao salvar estoque:', error);
            showToast('Erro ao atualizar estoque!', 'error');
        } finally {
            setSalvando(false);
        }
    };

    const limparTodos = () => {
        setProdutos(prev => prev.map(p => ({
            ...p,
            variacoes: (p.variacoes || []).map(v => ({ ...v, quantidadeAdicionar: 0 }))
        })));
    };

    /* Contagem de variações com adição por produto */
    const contagemPorProduto = (produto) => {
        return (produto.variacoes || []).filter(v => (v.quantidadeAdicionar || 0) > 0).length;
    };

    /* Estoque total do produto */
    const estoqueTotalProduto = (produto) => {
        return (produto.variacoes || []).reduce((acc, v) => acc + (parseInt(v.estoque) || 0), 0);
    };

    return (
        <section className='container-principal-adicionar-estoque'>
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className='conteudo-adicionar-estoque'>
                    <div className='titulo-adicionar-estoque'>
                        <h1>Adicionar Estoque em Massa</h1>
                    </div>
                    <BntVoltar />

                    <div className='barra-acoes-container'>
                        <div className='barra-pesquisa-estoque'>
                            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.6667 19.6667L28 28M12.7222 22.4444C11.4455 22.4444 10.1812 22.193 9.00169 21.7044C7.82213 21.2158 6.75036 20.4997 5.84757 19.5969C4.94478 18.6941 4.22865 17.6223 3.74006 16.4428C3.25147 15.2632 3 13.999 3 12.7222C3 11.4455 3.25147 10.1812 3.74006 9.00169C4.22865 7.82213 4.94478 6.75036 5.84757 5.84757C6.75036 4.94478 7.82213 4.22865 9.00169 3.74006C10.1812 3.25147 11.4455 3 12.7222 3C15.3007 3 17.7736 4.0243 19.5969 5.84757C21.4201 7.67084 22.4444 10.1437 22.4444 12.7222C22.4444 15.3007 21.4201 17.7736 19.5969 19.5969C17.7736 21.4201 15.3007 22.4444 12.7222 22.4444Z" stroke="#000" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <input
                                type='text'
                                placeholder='Pesquisar produto pelo nome'
                                value={termoPesquisa}
                                onChange={(e) => setTermoPesquisa(e.target.value)}
                            />
                        </div>
                        <div className='btns-expandir'>
                            <button className='btn-expandir-todos' onClick={expandirTodos}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Expandir Todos
                            </button>
                            <button className='btn-recolher-todos' onClick={recolherTodos}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 14L12 9L17 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Recolher Todos
                            </button>
                        </div>
                    </div>

                    {carregando ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando produtos...</h2>
                        </div>
                    ) : (
                        <div className='lista-produtos-estoque'>
                            {produtosFiltrados.length === 0 ? (
                                <div className='mensagem-vazio'>
                                    <p>Nenhum produto encontrado</p>
                                </div>
                            ) : (
                                produtosFiltrados.map((produto) => {
                                    const variacoes = produto.variacoes || [];
                                    if (variacoes.length === 0) return null;
                                    const isAberto = expandidos[produto.id_produto] || false;
                                    const qtdComAdicao = contagemPorProduto(produto);

                                    return (
                                        <div key={produto.id_produto} className={`card-produto-estoque ${isAberto ? 'aberto' : ''} ${qtdComAdicao > 0 ? 'com-adicao' : ''}`}>
                                            {/* Card Header */}
                                            <div className='card-header' onClick={() => toggleExpandido(produto.id_produto)}>
                                                <div className='card-header-info'>
                                                    <span className='estoque-badge-total'>{estoqueTotalProduto(produto)} un.</span>
                                                    <h3>{produto.nome}</h3>
                                                    <div className='meta-info'>
                                                        <span>{variacoes.length} variação{variacoes.length !== 1 ? 'ões' : ''}</span>
                                                        {produto.marca && <span>• {produto.marca}</span>}
                                                        {qtdComAdicao > 0 && (
                                                            <span className='badge-pendente'>{qtdComAdicao} pendente{qtdComAdicao !== 1 ? 's' : ''}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <svg className={`chevron ${isAberto ? 'open' : ''}`} width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                    <path d="M6 9L12 15L18 9" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>

                                            {/* Card Body - Variações */}
                                            {isAberto && (
                                                <div className='card-body'>
                                                    <div className='secao-variacoes'>
                                                        {variacoes.map((variacao, vIdx) => {
                                                            const qtdAdicionar = variacao.quantidadeAdicionar || 0;
                                                            const novoEstoque = (parseInt(variacao.estoque) || 0) + qtdAdicionar;
                                                            const variacaoLabels = [
                                                                variacao.tamanho && variacao.tamanho,
                                                                variacao.cor && variacao.cor,
                                                                variacao.material && variacao.material,
                                                            ].filter(Boolean);

                                                            return (
                                                                <div key={variacao.id} className={`variacao-card ${qtdAdicionar > 0 ? 'com-adicao' : ''}`}>
                                                                    <div className='variacao-header'>
                                                                        <span className='variacao-numero'>{vIdx + 1}</span>
                                                                        <div className='variacao-tags'>
                                                                            {variacaoLabels.length > 0 ? (
                                                                                variacaoLabels.map((label, i) => (
                                                                                    <span key={i} className='badge-variacao'>{label}</span>
                                                                                ))
                                                                            ) : (
                                                                                <span className='badge-variacao badge-unica'>Única</span>
                                                                            )}
                                                                        </div>
                                                                        {variacao.sku && <span className='variacao-sku'>{variacao.sku}</span>}
                                                                    </div>

                                                                    <div className='variacao-grid'>
                                                                        <div className='campo-estoque'>
                                                                            <label>Estoque Atual</label>
                                                                            <div className='valor-estoque atual'>
                                                                                {variacao.estoque ?? 0}
                                                                            </div>
                                                                        </div>
                                                                        <div className='campo-estoque campo-adicionar'>
                                                                            <label>Adicionar</label>
                                                                            <input
                                                                                type='number'
                                                                                min='0'
                                                                                value={qtdAdicionar}
                                                                                onChange={(e) => handleQuantidadeChange(produto.id_produto, variacao.id, e.target.value)}
                                                                                placeholder='0'
                                                                            />
                                                                        </div>
                                                                        <div className='campo-estoque'>
                                                                            <label>Novo Estoque</label>
                                                                            <div className={`valor-estoque novo ${qtdAdicionar > 0 ? 'ativo' : ''}`}>
                                                                                {novoEstoque}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    )}

                    {/* Ações de estoque */}
                    <div className='acoes-estoque'>
                        <button 
                            className='bnt-limpar' 
                            onClick={limparTodos}
                            disabled={variacoesComAdicao.length === 0}
                        >
                            Limpar Tudo
                        </button>
                        <button 
                            className='bnt-salvar' 
                            onClick={handleSalvarEstoque}
                            disabled={variacoesComAdicao.length === 0 || salvando}
                        >
                            {salvando ? 'Salvando...' : `Salvar Estoque (${variacoesComAdicao.length} variação${variacoesComAdicao.length !== 1 ? 'ões' : ''})`}
                        </button>
                    </div>
                </section>
            </main>
            <Rodape />
        </section>
    );
}
